import React from "react";
import "./ResiStepSection.css";
import { useNavigate } from 'react-router-dom';


export default function ResiStepSection() {
    const navigate = useNavigate();
      const handleRecruit = () => navigate('/onboarding');

  return (
    <section className="resi-step-section resi-animated-bg">
      <h2 className="resi-step-title">
        Get started in <span>1 hour</span> with Our Onboarding <br /> & Talent Suite
      </h2>

      <div className="resi-step-line">
        <div className="resi-step-point">
          <span>1</span>
        </div>
        <div className="resi-step-divider" />
        <div className="resi-step-point">
          <span>2</span>
        </div>
        <div className="resi-step-divider" />
        <div className="resi-step-point">
          <span>3</span>
        </div>
      </div>

      <div className="resi-step-grid">
        <div className="resi-step-card">
          <h3>Create an Account</h3>
          <p>
            Sign up for free and add your company details. Keep your documents
            ready for a quick setup.
          </p>
        </div>

        <div className="resi-step-card">
          <h3>Onboard Your Workforce</h3>
          <p>
            Add employee information in bulk or let new hires self-onboard
            through automated workflows.
          </p>
          <button className="resi-step-btn" onClick={handleRecruit}>Start Now →</button>
        </div>

        <div className="resi-step-card">
          <h3>Onboard Your Workforce</h3>
          <p>
            Generate personalized offer letters, map skills instantly, and
            kickstart training modules all from your dashboard.
          </p>
        </div>
      </div>
    </section>
  );
}
